import React, { useRef } from 'react';

import { ReactComponent as IconRemove } from 'icons/icon-remove.svg';

import useMedia from 'hooks/useMedia';

import Button from 'components/elements/button';
import Modal from 'components/utility/Modal/Modal';
import { RemoveButton } from 'components/Selector/DSPSelector/SelectedDSPList/DSPItem/DSPItem';
import Location from 'components/UserProfileOnboarding/components/OnboardingForm/components/Location';
import Division from 'components/UserProfileOnboarding/components/OnboardingForm/components/Division';
import Role from 'components/UserProfileOnboarding/components/OnboardingForm/components/Role';

import {
  ModalWrapper,
  RemoveButtonWrapper,
  ModalTitle,
  ModalSubTitle,
  ModalText,
  BlockWrapper,
  ItemTitle,
  ItemSubTitle,
  ItemWrapper,
  ButtonWrapper,
} from './styles';

interface IEditModalProps {
  userProfile?: any;
  setIsEditModalOpen: Function;
}

const EditModal: React.FC<IEditModalProps> = (props) => {
  const { userProfile, setIsEditModalOpen } = props;

  const isLargeScreen = useMedia('(min-height: 800px)');

  const locationRef: any = useRef();
  const divisionRef: any = useRef();
  const roleRef: any = useRef();

  const onSave = (): void => {
    locationRef?.current?.externalSave();
    divisionRef?.current?.externalSave();
    roleRef?.current?.externalSave();
    setIsEditModalOpen(false);
  };

  const onClose = (): void => setIsEditModalOpen(false);

  return (
    <Modal maxWidth="1050px">
      <ModalWrapper>
        <RemoveButtonWrapper>
          <RemoveButton onClick={onClose} isRemovable color="#001247">
            <IconRemove />
          </RemoveButton>
        </RemoveButtonWrapper>
        <ModalTitle>Account Settings</ModalTitle>
        <ModalSubTitle>Account information</ModalSubTitle>
        <ModalText>Tell us about yourself, {userProfile?.name}.</ModalText>
        <BlockWrapper>
          <ItemWrapper>
            <div>
              <ItemTitle>Select Office Location</ItemTitle>
              <ItemSubTitle>
                Choose the location of your local Office
              </ItemSubTitle>
            </div>
            <Location ref={locationRef} withoutText />
          </ItemWrapper>
          <ItemWrapper maxHeight={isLargeScreen ? '15em' : '14em'}>
            <div>
              <ItemTitle>Select Label or Department</ItemTitle>
              <ItemSubTitle>
                Choose the Label or Department you report to{' '}
              </ItemSubTitle>
            </div>
            <Division ref={divisionRef} alignLeft />
          </ItemWrapper>
          <ItemWrapper maxHeight={isLargeScreen ? '11em' : '9.9em'}>
            <div>
              <ItemTitle>Select Role</ItemTitle>
              <ItemSubTitle>
                Choose the Role that best describes what you do{' '}
              </ItemSubTitle>
            </div>
            <Role ref={roleRef} />
          </ItemWrapper>
        </BlockWrapper>
        <ButtonWrapper>
          <Button variant="primary2" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSave}>
            Save
          </Button>
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  );
};

export default EditModal;
